
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pushkincard",
      function () {
        return require("private-next-pages/pushkincard/index.tsx");
      }
    ]);
  